"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CustomDatePicker.tsx
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var DatePicker_1 = require("@/react-app/common/components/DatePicker/DatePicker");
var SelectDropdown_1 = __importDefault(require("@/react-app/common/components/SelectDropdown"));
var DateRangePicker_1 = require("@/react-app/common/components/DatePicker/DateRangePicker");
var parseDate = function (date) {
    if (!date)
        return [null, null];
    if (date.includes(' TO ')) {
        return date
            .slice(1, -1)
            .split(' TO ')
            .map(function (date) { return (date !== '*' ? new Date(date) : null); });
    }
    return [new Date(date)];
};
function DateFilterInput(_a) {
    var filterId = _a.filterId, placeholder = _a.placeholder, filterValue = _a.filterValue, handleInputChange = _a.handleInputChange, inputRef = _a.inputRef, maxNow = _a.maxNow, isOpen = _a.isOpen;
    var _b = __read((0, react_1.useState)('1'), 2), selectedDateMode = _b[0], setSelectedDateMode = _b[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = __read(parseDate(filterValue), 2), from = _c[0], to = _c[1];
    var dropdownItems = [
        { id: '1', text: t('SEARCH.SEARCH_QUERY_BUILDER.SINGLE_DAY') },
        { id: '2', text: t('SEARCH.SEARCH_QUERY_BUILDER.DATE_RANGE') },
    ];
    // this is for rerendering datepickers, for example when reset button is clicked
    var _d = __read((0, react_1.useState)(0), 2), filterResetKey = _d[0], setFilterResetKey = _d[1];
    var _e = __read((0, react_1.useState)(maxNow ? new Date() : null), 1), maxDate = _e[0];
    // clear and rerender when reset button is clicked
    (0, react_1.useEffect)(function () {
        if (!filterValue) {
            setFilterResetKey(function (prevKey) { return prevKey + 1; });
        }
    }, [filterValue]);
    (0, react_1.useEffect)(function () {
        var isRange = filterValue && filterValue.includes(' TO ');
        if (isRange)
            return setSelectedDateMode('2');
        setFilterResetKey(function (prev) { return prev + 1; });
    }, [isOpen]);
    var handleDateRangeChange = function (from, to) {
        if (!from && !to) {
            handleInputChange(filterId, '');
            return;
        }
        var fromString = from ? from.toISOString() : '*';
        var toString = to ? to.toISOString() : '*';
        var newDateRange = "[".concat(fromString, " TO ").concat(toString, "]");
        handleInputChange(filterId, newDateRange);
    };
    var handleDateModeChange = function (id) {
        setSelectedDateMode(id);
        if (id === '1') {
            if (from) {
                handleInputChange(filterId, from.toISOString());
            }
        }
        else {
            if (from) {
                from.setHours(0);
                from.setMinutes(1);
            }
            handleDateRangeChange(from, to);
        }
    };
    return (react_1.default.createElement("div", { className: "filter-date-wrapper" },
        react_1.default.createElement(SelectDropdown_1.default, { items: dropdownItems, selectedItemId: selectedDateMode, onItemSelected: function (id) { return handleDateModeChange(id); } }),
        react_1.default.createElement("div", { className: "filter-group" },
            selectedDateMode === '2' && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(DateRangePicker_1.DateRangePicker, { key: "range-".concat(filterResetKey), fromDate: from, toDate: to, setFromDate: function (newFrom) {
                        handleDateRangeChange(newFrom, to);
                    }, setToDate: function (newTo) {
                        handleDateRangeChange(from, newTo);
                    }, defaultMaxValue: maxDate || undefined, allowToNull: true, allowFromNull: true }))),
            selectedDateMode === '1' && (react_1.default.createElement(DatePicker_1.DatePicker, { key: "equal-".concat(filterResetKey), placeholder: placeholder, value: from || undefined, maxValue: maxDate || undefined, allowNull: true, onChange: function (date) {
                    if (!date) {
                        handleInputChange(filterId, '');
                        return;
                    }
                    if (date !== from) {
                        var year = date.getFullYear();
                        var month = String(date.getMonth() + 1).padStart(2, '0');
                        var day = String(date.getDate()).padStart(2, '0');
                        var formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
                        handleInputChange(filterId, formattedDate);
                    }
                }, defaultRef: inputRef, dateFormat: "yyyy-MM-dd", dataCy: "date-picker-from", hideTime: true })))));
}
exports.default = DateFilterInput;
